import React from 'react'
import { withStyles } from '@material-ui/core'
import Headline from '../../../uiKit/texts/Headline'
import { HomeHeader } from '../../account/components/HomeHeader'
import { setBrowserTabTitle } from '../../../helpers/setBrowserTabTitle'

const styles = theme => ({
  container: {
    backgroundColor: theme.tabs.home.background(),
    display: 'flex',
    flexDirection: 'column',
    padding: '80px 40px 40px',
    minHeight: '100vh',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100%',
  },
  '@media (max-width: 991px)': {
    container: {
      padding: '90px 20px 20px !important',
    },
  },
})

class BotsLegacy extends React.Component {
  componentDidMount() {
    setBrowserTabTitle('Admin Panel')
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <HomeHeader title="Admin Panel" />
        <div className={classes.container}>
          <Headline title="Your bots" />
          <div className={classes.content}>{this.props.children}</div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(BotsLegacy)
